import * as Sentry from "@sentry/browser";
import { isTawkError } from "../utils/sentry/errors/tawk";
import { processSentryEvent } from "../utils/sentry/process-sentry-event";

interface OcpSentryBootstrapConfig {
    dsn?: string;
    version?: string;
    env?: string;
    stack?: string;
    user?: {
        id: string;
        email: string;
        username?: string;
    };
}

declare global {
    interface Window {
        __ocpSentryBootstrap?: OcpSentryBootstrapConfig;
    }
}

const bootstrapConfig = window.__ocpSentryBootstrap;
if (
    bootstrapConfig?.dsn &&
    !location.hostname.includes("local") &&
    Sentry.getClient() === undefined
) {
    Sentry.init({
        dsn: bootstrapConfig.dsn,
        release: bootstrapConfig.version,
        environment: bootstrapConfig.env,
        beforeSend(event) {
            processSentryEvent(event, isTawkError(event));
            return event;
        },
    });
    if (bootstrapConfig.stack) {
        Sentry.setTag("installation", bootstrapConfig.stack);
    }
    if (bootstrapConfig.user) {
        Sentry.setUser(bootstrapConfig.user);
    }
}
